import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PriceSimulationDetailContainer from '../../../Containers/Settings/PriceSimulation/PriceSimulationDetailContainerBeta';

export default function PriceSimulationLayout() {
    return (
        <Routes>
            <Route index element={<PriceSimulationDetailContainer />} />
        </Routes>
    );
}
